import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconModule } from 'src/app/icon/icon.module';
import { MaterialModule } from 'src/app/material.module';
import { DEFAULT_LANGUAGE, LANGUAGES } from 'src/app/shared/constants';

@Component({
  selector: 'app-language-dropdown',
  imports: [MaterialModule, TranslateModule, IconModule],
  templateUrl: './language-dropdown.component.html'
})
export class LanguageDropdownComponent {
  // 'icon' = flag-only button (app header), 'labeled' = bordered button with the language name (sign-in pages)
  @Input() appearance: 'icon' | 'labeled' = 'icon';
  @Input() menuClass = '';

  get selectedLanguage() {
    const language = localStorage.getItem('language');
    if (language) {
      return LANGUAGES.find(lang => lang.code === language);
    }
    return LANGUAGES.find(lang => lang.code === DEFAULT_LANGUAGE);
  }

  set selectedLanguage(lang: any) {
    localStorage.setItem('language', lang.code);
  }

  constructor(private translate: TranslateService) {
    this.translate.use(this.selectedLanguage.code);
  }

  public languages = LANGUAGES;

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }
}
